import Loading from 'quasar/src/plugins/Loading.js';import QSpinnerPuff from 'quasar/src/components/spinner/QSpinnerPuff.js';;
let hiderFunction = () => ({});
/* Returns hider function */
const show = (params) => {
    hiderFunction = Loading.show({
        // @ts-ignore
        spinner: QSpinnerPuff,
        spinnerColor: 'amber',
        spinnerSize: 140,
        message: (params === null || params === void 0 ? void 0 : params.htmlMessage) || (params === null || params === void 0 ? void 0 : params.message),
        messageColor: 'amber',
        duration: 4000,
        customClass: 'custom-class'
    });
    return hiderFunction;
};
const hide = () => { hiderFunction(); };
const fullScreenLoading = { show, hide };
export default fullScreenLoading;
